import ds from './DataSourceService'

const baseUrl = '/apartment-types'

const getApartmentTypeById = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id)
}

const addApartmentType = apartmentType => {
  return ds.apiClientThinkHome.post(baseUrl, apartmentType)
}

const updateApartmentType = apartmentType => {
  return ds.apiClientThinkHome.patch(
    baseUrl + '/' + apartmentType.id,
    apartmentType
  )
}

const deleteApartmentType = apartmentType => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + apartmentType)
}
export default {
  getApartmentTypeById,
  addApartmentType,
  updateApartmentType,
  deleteApartmentType
}
